// Imports
import { useState, useEffect } from "react"

export const heroContainerMediaQueries = {
  xl: 1568,
  lg: 980,
  md: 672,
  sm: 378
}

export const useWindowWidth = () => {
  const [windowWidth, setWindowWidth] = useState(0)

  useEffect(() => {
    if (windowWidth === 0) setWindowWidth(window.innerWidth)
    const handleWindowReWidth = () => {
      setWindowWidth(window.innerWidth)
    }

    window.addEventListener("resize", handleWindowReWidth)
    return () => {
      window.removeEventListener("resize", handleWindowReWidth)
    }
  }, [windowWidth])

  return windowWidth
}
